<template>
  <div class="login-page">
    <div class="login-wrapper">
      <div v-if="userFoundByToken">
        <form v-if="!success" class="invitation-form" @submit.prevent="checkFields">
          <div class="title_group">
            <h2>{{$t('ui.auth.create_account_title')}}</h2>
            <p class="subtitle">{{$t('ui.auth.create_account_subtitle')}}</p>
          </div>
          <field label=" " name="token" type="hidden" v-model="token"></field>
          <field :placeholder="$t('ui.auth.firstname')" name="firstname" label="ui.auth.firstname" v-model="firstname"></field>
          <field :placeholder="$t('ui.auth.lastname')" name="lastname" label="ui.auth.lastname"  v-model="lastname"></field>
          <field :placeholder="$t('ui.auth.password')" name="password" type="password" label="ui.auth.password" v-model="password"></field>
          <field :placeholder="$t('ui.auth.password_confirmation')" name="password_confirmation" type="password" label="ui.auth.password_confirmation" v-model="password_confirmation"></field>
          <div class="submit">
            <input type="submit" class='btn btn-primary btn-login' data-action="user.password_reset" :value="$t('ui.auth.confirm')"/>
          </div>
        </form>
        <div v-else class="invitation-confirm">
          <h2>{{$t('ui.auth.create_account_title_confirm')}}</h2>
          <p class="subtitle">{{$t('ui.auth.create_account_subtitle_confirm')}}</p>
          <i class="icon yule-icon-success"></i>
        </div>
      </div>
      <div v-else class="invitation-confirm">
        <h2>{{$t('ui.auth.user_not_found')}}</h2>
        <p class="subtitle" v-html="$t('ui.auth.user_not_found_subtitle')"></p>
        <i class="icon yule-icon-error"></i>
      </div>
      <hr>
      <div class="actions">
        <router-link :to="{name:'login'}"><i class="icon yule-icon-chevron-left"></i> {{$t('ui.auth.go_to_login')}} </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Field from '@/components/helpers/DataInput/Field'
import Auth from '@/api/Auth'
import UserApi from "@/api/User.js";


export default {
  components: {Field},
  metaInfo () {
    return {
      title: this.$t("ui.meta_info.invitation")
    }
  },
  data(){
    return{
      password: '',
      password_confirmation: '',
      firstname: '',
      lastname: '',
      success: false,
      error: '',
      token: '',
      userFoundByToken: Boolean
    }
  },
  mounted(){
    this.token = this.$route.params.token

    let userApi = new UserApi();
    userApi.getUserDetailsByToken(this.token).then((item) => {
      this.userFoundByToken = true
      this.firstname = item['resource']['firstname']
      this.lastname = item['resource']['lastname']
    }).catch(e => {
      this.userFoundByToken = false
    });
  },
  methods:{
    checkFields(){
      let auth = new Auth()
      this.errros = []
      if(this.firstname === '' || this.firstname === null){
        this.$store.commit('SET_NOTIFICATION', {
          'title': this.$t('errors.authentication.empty_firstname'),
          'type': 'error'
      })
      }else if(this.lastname === ''|| this.lastname === null){
        this.$store.commit('SET_NOTIFICATION', {
          'title': this.$t('errors.authentication.empty_lastname'),
          'type': 'error'
      })
      }else if(this.password == this.password_confirmation){
        if(this.password === '' || this.password === null){
          this.$store.commit('SET_NOTIFICATION', {
            'title': this.$t('errors.authentication.empty_password'),
            'type': 'error'
        })
        }else if(!this.validatePassword(this.password)){
          this.$store.commit('SET_NOTIFICATION', {
            'title': this.$t('errors.authentication.wrong_password'),
            'type': 'error'
        })
        }else{
          this.error = null
          auth.confirmAccount(this.token,this.password,this.password_confirmation, this.firstname, this.lastname, this.$i18n.locale).then(result=>{
            this.success = true
          }).catch(e=>{
            this.error = e.response.data.errors[0]
          })
        }
      }else{
        this.$store.commit('SET_NOTIFICATION', {
          'title': this.$t('errors.authentication.wrong_password_confirmation'),
          'type': 'error'
      })
      }
    },
    validatePassword(password){
      if(password.length < 8){
        return false
      }
      let numberRegex = /[0-9]/
      if(!numberRegex.test(password)){
        return false
      }
      let letterRegex = /[a-z]/
      if(!letterRegex.test(password)){
        return false
      }
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
.invitation-form{
  margin-top: 0px;
  margin-bottom: 80px;
}
  .icon{
    vertical-align: text-top;
    font-size: 18px;
  }
.illustration{
  display: block;
  margin: 20px auto;
}
.invitation-confirm{
  text-align: center;
  padding: 80px 0;
  .icon {
    &.yule-icon-success {
      font-size: 120px;
      color: $green;
    }
    &.yule-icon-error {
      font-size: 100px;
      color: $red;
    }
  }
  .subtitle {
    margin-top: 10px !important;
  }
}
.login-wrapper {
  padding-top: 3.5%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  h2, p {
    text-align: center;
  }
  .title_group {
    margin-bottom: 60px;
  }
}

#public-app .login-page h2{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// Invitation.vue?4a1ee6c4